import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenantFeatureFlag = (token, TenantID, FeatureFlagID) => {
    return fetch(`${apiUrl}tenant_feature_flags`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            TenantID,
            FeatureFlagID
        })
    });
}

export default postTenantFeatureFlag